<ngx-spinner
	bdColor="rgba(75, 55, 100, 0.5)"
	size="large"
	color="#fff"
	type="line-scale-pulse-out">
	<span class="chevron left"></span>
	<span class="chevron right"></span>
</ngx-spinner>
<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
	<div class="m-content">
			<!-- FORM -->
			<form
			[formGroup]="form"
			*ngIf="form"
			class="m-form m-form--fit m-form--label-align-right">
				<div>
					<!-- EVENT -->
					<div class="m-portlet">
					<div formGroupName="event">
						<div class="m-portlet__head">
							<div class="m-portlet__head-caption">
								<div class="m-portlet__head-title">
									<h3 class="m-portlet__head-text" *ngIf="!cue5050Id">
										CUE5050 EVENT INFORMATION
									</h3>
								</div>
							</div>
						</div>
						<div class="m-portlet__body">
							<div class="m-form__section m-form__section--first">
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Event Name:
									</label>
									<div class="col-lg-3">
										<input
											formControlName="name"
											type="text"
											id="name"
											class="form-control m-input"
											placeholder=""
											/>
										<app-validation-display
											[control]="formControls('event').controls.name"
											errorMessage="Event name is required"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Charity:
									</label>
									<div class="col-lg-3">
										<select
											formControlName="merchantId"
											class="col-lg-12 col-m-4 form-control m-input"
											id="merchantId"
											name="merchantIdSelect"
											>
											<option selected value="0">-- Select a Charity --</option>
											<option
											*ngFor="let m of linkedMerchants"
											[selected]="m.accountId == formControls('event').controls.merchantId.value"
											[value]="m.accountId"
											>
											{{ m.accountName }}
											</option>
										</select>
										<span class="m-form__help">
										Choose a charity from this list that will benefit from this event.
										</span><br />
										<p style="color:red; padding: 0; font-family: 'Open Sans', sans-serif; font-size: 12px; font-weight: 300;"
											*ngIf="cue5050?.status > 1">
											Cannot edit the Charity of an event once it has occurred
										</p>
										<app-validation-display
											[control]="formControls('event').controls.merchantId"
											errorMessage="Charity is required"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Fundraising Goal:
									</label>
									<div class="col-lg-3">
										<label class="input-dollar-sign col-form-label">
										$
										</label>
										<input
											formControlName="fundraisingGoal"
											type="text"
											(keyup)="removeLeadingZeros(formControls('event').controls.fundraisingGoal)"
											pattern="\d+(\.\d{1,2})?"
											id="fundraisingGoal"
											class="input-dollar-field form-control m-input"
											/>
										<app-validation-display
											[control]="formControls('event').controls.fundraisingGoal"
											errorMessage="Please enter in a valid dollar amount"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Event Start/End Date:
									</label>
									<div class="col-lg-3">
										<app-service-period
										[minDays]="1"
										[showTooltip]="false"
										formControlName="realEventPeriod"
										></app-service-period>
										<span class="m-form__help">
										Customer facing time period for which this event will remain active</span
											><br />
										<app-validation-display
											[control]="formControls('event').controls.realEventPeriod"
											errorMessage="Please select a valid date range for this event"
											></app-validation-display>
									</div>
								</div>

								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Enable Online Sales:
									</label>
									<div style="padding-top: 7px;" class="col-lg-3">
										<label class="switch">
										<input
											formControlName="enableOnlineSales"
											type="checkbox"
											/>
										<span class="slider round"></span>
										</label>
									</div>
								</div>
								<!--
									<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Terms of Service URL:
										</label>
										<div class="col-lg-3">
											<input
												formControlName="termsOfServiceUrl"
												type="text"
												id="termsOfServiceUrl"
												pattern="^https://[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?"
												class="form-control m-input"
												placeholder="https://"
												/>
											<app-validation-display
												[control]="formControls('event').controls.termsOfServiceUrl"
												errorMessage="Please supply a valid link to your Terms of Service"
												></app-validation-display>
										</div>
									</div>




									<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Primary Color:
										</label>
										<div class="col-lg-3">
											<input formControlName="primaryColor" [cpAlphaChannel]="'disabled'" maxlength="7" class="form-control m-input"
											[value]="formControls('event').controls.primaryColor.value"
											(colorPickerChange)="formControls('event').controls.primaryColor.value = $event; formControls('event').controls.primaryColor.updateValueAndValidity();"
											[colorPicker]="formControls('event').controls.primaryColor.value" [cpDisableInput]="true" [style.background]="formControls('event').controls.primaryColor.value">
											<app-validation-display
											[control]="formControls('event').controls.primaryColor"
											errorMessage="Please choose a valid color"
											></app-validation-display>
										</div>
									</div>

													<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Secondary Color:
										</label>
										<div class="col-lg-3">
											<input [cpAlphaChannel]="'disabled'" maxlength="7" class="form-control m-input"
												[value]="formControls('event').controls.secondaryColor.value"
												(colorPickerChange)="formControls('event').controls.secondaryColor.value = $event; formControls('event').controls.secondaryColor.updateValueAndValidity();"
												[colorPicker]="formControls('event').controls.secondaryColor.value"
												[cpDisableInput]="true"
												formControlName="secondaryColor"
												[style.background]="formControls('event').controls.secondaryColor.value">
											<app-validation-display
												[control]="formControls('event').controls.secondaryColor"
												errorMessage="Please choose a valid color"
												></app-validation-display>
														</div>
									</div>

													<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Logo Image:
										</label>
										<div class="col-lg-3">


										</div>
									</div>

													<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Banner Image:
										</label>
										<div class="col-lg-3">


										</div>
									</div> -->
							</div>
						</div>
					</div>
						<div *ngIf="formControls('event').controls.enableOnlineSales.value">
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Geo-restrict by state:
								</label>
								<div style="padding-top: 7px;" class="col-lg-3">
									<label class="switch">
									<input
										formControlName="restrictState"
										type="checkbox"
										/>
									<span class="slider round"></span>
									</label>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Geo-restrict by city:
								</label>
								<div style="padding-top: 7px;" class="col-lg-3">
									<label class="switch">
									<input
										formControlName="restrictCity"
										type="checkbox"
										/>
									<span class="slider round"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<!-- END EVENT -->
				</div>

				<!--LOCATION -->
				<app-location-form
				*ngIf="form"
				formName="EVENT VENUE"
				[disableForm]="true"
				[disableSelection]="eventId > 0"
				[parentGroup]="formControls('event')"
				[locationData]="cue5050?.event.location">
				</app-location-form>
				<!--END LOCATION -->

				<!-- TICKETING -->
				<div class="m-portlet" style="width: 100%">
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text" *ngIf="!editMode">
									POT, TICKETS, & WINNINGS
								</h3>
							</div>
						</div>
					</div>
					<div class="m-portlet__body">
						<div class="m-form__section m-form__section--first">
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Event Start Time:
								</label>
								<div class="col-lg-3">
									<input
										class="form-control m-input"
										type="time"
										formControlName="eventStartTime"
										id="eventStartTime"
										name="eventStartTime"
										min="00:00" max="24:00">
									<i *ngIf="eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
									<span class="m-form__help">
									Customer facing time the event will be started, and tickets will be for sale</span
										><br />
									<app-validation-display
										[control]="formControls('eventStartTime')"
										errorMessage="Please select a valid time"
										></app-validation-display>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Winner Selection Time:
								</label>
								<div class="col-lg-3">
									<input
										class="form-control m-input"
										type="time"
										formControlName="winnerSelectTime"
										id="winnerSelectTime"
										name="winnerSelectTime"
										min="00:00" max="24:00">
									<i *ngIf="eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
									<span class="m-form__help">
									Customer facing time at which the winner will be chosen, and the event will close</span
										><br />
									<app-validation-display
										[control]="formControls('winnerSelectTime')"
										errorMessage="Please select a valid time"
										></app-validation-display>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								</label>
								<div class="col-lg-3">
									<span style="font-weight: 800;" class="m-form__help">
									Tickets will be for sale starting on
									</span>
									<span style="font-weight: 1000;" class="m-form__help">
										{{ getStartDateTime() | date: 'EEEE, MMMM d, y, h:mm a' }} {{ locationFormControls('timeZone')?.value }}
									</span>
									<span style="margin-top: 15px; font-weight: 800;" class="m-form__help">
										and a winner will be drawn on
									</span>
									<span style="font-weight: 1000;" class="m-form__help">
										{{ getEndDateTime() | date: 'EEEE, MMMM d, y, h:mm a' }} {{ locationFormControls('timeZone')?.value }}
									</span>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label"></label>
								<div  class="col-lg-3">
									<span style="font-weight: 800;" class="m-form__help">
									The total pot is split between your organization, the charity, CUE Audio Fundraising, and the winner. CUE takes 10% of the total pot to cover business expenses, transaction fees, and administration fees
									</span>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Percent Winner:
								</label>
								<div class="col-lg-3">
									<input
										formControlName="percentWinner"
										type="number"
										pattern="^[0-9]*$"
										id="name"
										class="form-control m-input"
										placeholder=""
										/>
									<i *ngIf=" eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
									<span class="m-form__help">
									The percentage of the total pot that will be paid out to the owner of the winning ticket drawn at the end of the event
									</span><br /><span class="m-form__help">
									This controls how much of the pot is ultimately received by the charity
									</span>
									<app-validation-display
										[control]="formControls('percentWinner')"
										errorMessage="Please choose a valid winner percent"
										></app-validation-display>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Expense Percent:
								</label>
								<div class="col-lg-3">
									<input
										formControlName="expensePercent"
										type="text"
										pattern="^[0-9]*$"
										id="name"
										class="form-control m-input"
										placeholder=""
										/>
									<i *ngIf=" eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
									<span class="m-form__help">
									The percentage of the total pot that will be held and transferred to your account for business expenses incurred by your organization
									</span><br />
									<app-validation-display
										[control]="formControls('expensePercent')"
										errorMessage="Please choose a valid expense percent"
										></app-validation-display>
									<br /><br />
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label"></label>
								<div  class="col-lg-3">
									<span style="font-weight: 800;" class="m-form__help">
										Breakdown of a $100 ticket purchase.
									</span>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label"></label>
								<div class="col-lg-3" style="flex-direction: column;">
									<span style="display: block;">Paid to Vendor: {{ calculatePercentBreakdown().percentToVendor | currency }} </span>
									<span style="display: block;">Paid to Winner: {{ calculatePercentBreakdown().percentToWinner | currency }}</span>
									<span style="display: block;">Paid to Charity: {{ calculatePercentBreakdown().percentToCharity | currency }}</span>
									<span style="display: block; width: 300px;">Processing Fees: {{ calculatePercentBreakdown().processingFees.online | currency }} (if online), {{ calculatePercentBreakdown().processingFees.onsite | currency }} (if onsite)</span>
									<span style="display: block;">Administration Fees: {{ calculatePercentBreakdown().administrationFees | currency }}</span>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Expense Cap:
								</label>
								<div class="col-lg-3">
									<label class="input-dollar-sign col-form-label">
									$
									</label>
									<input
										formControlName="expenseCap"
										type="text"
										(keyup)="removeLeadingZeros(formControls('expenseCap'))"
										pattern="\d+(\.\d{1,2})?"
										id="expenseCap"
										class="input-dollar-field form-control m-input"
										/>
									<span class="m-form__help">
									Choose the maximum dollar amount that should be set aside for expenses, enter zero for no limit
									</span><br />
									<app-validation-display
										[control]="formControls('expenseCap')"
										errorMessage="Please enter in a valid dollar amount"
										></app-validation-display>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Minimum Display Value:
								</label>
								<div class="col-lg-3">
									<label class="input-dollar-sign col-form-label">
									$
									</label>
									<input
										formControlName="minimumDisplayValue"
										(keyup)="removeLeadingZeros(formControls('minimumDisplayValue'))"
										type="text"
										pattern="\d+(\.\d{1,2})?"
										id="minimumDisplayValue"
										class="input-dollar-field form-control m-input"
										/>
									<i *ngIf=" eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
									<span class="m-form__help">
										This value controls the minimum pot amount that will be shown on the website or XML feeds. For example, if $100 is put here, the pot display $100 until that amount is reached.
									</span><br />
									<!-- <p style="color:red; padding: 0; font-family: 'Open Sans', sans-serif; font-size: 12px; font-weight: 300;"
										*ngIf="formControls('startingPotSeed').value > 0">
										Please note: Your CUE Fundraising Stripe balance must contain at least {{formControls('startingPotSeed').value | currency}} before your event for this feature to work correctly.
										An invoice will be emailed to your event's primary contact when this event is created.
									</p> -->
									<app-validation-display
										[control]="formControls('minimumDisplayValue')"
										errorMessage="Please enter in a valid dollar amount"
										></app-validation-display>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Total Tickets Available:
								</label>
								<div  class="col-lg-3">
									<input
										formControlName="ticketsAvailable"
										(change)="generateFirstFiveTickets()"
										type="number"
										id="name"
										class="form-control m-input"
										/>
									<i *ngIf=" eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
									<span class="m-form__help">
									Specify the maximum number of tickets available for sale
									</span><br />
									<app-validation-display
										[control]="formControls('ticketsAvailable')"
										errorMessage="Please enter in a valid number between 100 and {{ getMaxTicketsAvailable() | number:'1.0':'en-US' }}"
										></app-validation-display>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Show Advanced Ticket Options:
								</label>
								<div style="padding-top: 7px;" class="col-lg-3">
									<label class="switch">
									<input
									[ngModelOptions]="{standalone: true}"
									[(ngModel)]="showAdvancedOptions"
									[disabled]="viewing"
									type="checkbox"
									/>
									<span class="slider round"></span>
									</label>
									<i *ngIf=" eventId > 0"  class="tooltip-icon danger-icon flaticon-exclamation-2" style="top: 0;" tooltip="Can't edit this field after the event has been scheduled"></i>
								</div>
							</div>
							<div [hidden]="!showAdvancedOptions">
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Ticket Prefix:
									</label>
									<div class="col-lg-3">
										<input
											(focusout)="generateFirstFiveTickets()"
											formControlName="ticketNumberPrefix"
											type="text"
											pattern="^[a-z]*[A-Z]*$"
											id="name"
											class="form-control m-input"
											/>
										<span class="m-form__help">
										Optionally choose a prefix to append to the ticket numbers
										</span><br />
										<app-validation-display
											[control]="formControls('ticketNumberPrefix')"
											errorMessage="Please enter a valid prefix containing only letters"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Ticket Suffix:
									</label>
									<div class="col-lg-3">
										<input
											(focusout)="generateFirstFiveTickets()"
											formControlName="ticketNumberSuffix"
											type="text"
											pattern="^[a-z]*[A-Z]*$"
											id="name"
											class="form-control m-input"
											/>
										<span class="m-form__help">
										Optionally choose a suffix to append to the ticket numbers
										</span><br />
										<app-validation-display
											[control]="formControls('ticketNumberSuffix')"
											errorMessage="Please enter a valid suffix containing only letters"
											></app-validation-display>
									</div>
								</div>
								<!--<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Use Random Ticket Numbers:
									</label>
									<div style="padding-top: 7px;" class="col-lg-3">
										<label class="switch">
										<input
											(change)="generateFirstFiveTickets()"
											formControlName="useRandomNumbers"
											type="checkbox"
											/>
										<span class="slider round"></span>
										</label>
										<i *ngIf=" eventId > 0"  class="tooltip-icon danger-icon flaticon-exclamation-2" style="top: 0;" tooltip="Can't edit this field after the event has been scheduled"></i>
									</div>
								</div>-->
								<div *ngIf="!formControls('useRandomNumbers').value" class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Starting Ticket Number:
									</label>
									<div class="col-lg-3">
										<input
										formControlName="startingTicketNumber"
										(focusout)="generateFirstFiveTickets()"
										(change)="formControls('ticketsAvailable').updateValueAndValidity()"
										type="number"
										id="name"
										class="form-control m-input"
										/>
										<i *ngIf=" eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
										<span class="m-form__help">
										Specify what the first ticket number will be
										</span><br />
										<app-validation-display
											[control]="formControls('startingTicketNumber')"
											errorMessage="Please enter in a valid number greater than zero"
											></app-validation-display>
									</div>
								</div>
								<div *ngIf="!formControls('useRandomNumbers').value" class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Ticket Increment:
									</label>
									<div class="col-lg-3">
										<input
										(focusout)="generateFirstFiveTickets()"
										formControlName="ticketIncrement"
										[ignoreWhiteSpace]
										pattern="^\d+?"
										(change)="formControls('ticketsAvailable').updateValueAndValidity()"
										type="number"
										id="name"
										class="form-control m-input"
										/>
										<i *ngIf=" eventId > 0" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="Can't edit this field after the event has been scheduled"></i>
										<span class="m-form__help">
										Specify how much to increase the ticket number with each new ticket purchased, this does not affect the odds of the game
										</span><br />
										<app-validation-display
											[control]="formControls('ticketIncrement')"
											errorMessage="Please enter in a valid number greater than zero"
											></app-validation-display>
									</div>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Sample Ticket Numbers:
								</label>
								<div class="col-lg-3">
									<div *ngFor="let n of firstFiveTickets" >
										<span class="m-form__help">
										{{n }}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- END TICKETING -->

				<!-- TICKET TIERS -->
				<div class="m-portlet" style="width: 100%">
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text">
									PRICING TIERS
								</h3>
							</div>
						</div>
					</div>
					<div class="m-portlet__body" style="padding-top: 0;">
						<div class="m-form__section m-form__section--first">
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label"></label>
								<div  class="col-lg-3">
									<span class="m-form__help" style="font-weight: 800;">
									Create the pricing tiers available for purchase. These will appear as a product list on the CUE POS App and your fundraiser website
									</span><br />
									<span class="m-form__help">
									Ex: Gold Tier, 100 tickets for $40
									</span>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Ticket Tiers:
								</label>
								<div class="col-lg-4">
									<div
										formArrayName="pricingTiers"
										*ngFor="let t of formControls('pricingTiers').controls; let i = index"
										>
										<div *ngIf="t" [formGroupName]="i" style="display: flex; justify-content: start;" [ngStyle]="{'padding-top': i !== 0 ? '15px' : '0'}">
										<input
											formControlName="description"
											type="text"
											style="width: 100px;"
											id="tierDescription"
											class="form-control m-input"
											placeholder="Name"
											/>
										<input
										formControlName="amount"
										style="width: 100px;"
										id="tierQuantity"
										type="text"
										[ignoreWhiteSpace]
										(keyup)="removeLeadingZeros(t.controls.amount)"
										class="form-control m-input"
										placeholder="Quantity"
										/>
										<div style="display: flex; width: 100px;">
											<label style="font-size: 1.2rem; margin-top: 7px; margin-right: 3px;">$</label>
											<input
											formControlName="price"
											style="width: 90px;"
											pattern="\d+(\.\d{1,2})?\s?"
											(keyup)="removeLeadingZeros(t.controls.price)"
											id="tierPrice"
											type="text"
											[ignoreWhiteSpace]
											class="form-control m-input"
											placeholder="Price"
											/>
										</div>
										<a *ngIf="i !== 0 && !eventId" (click)="deletePricingTier(i)" href="#" class="m-menu__link" style="text-decoration: none; margin-top: 5px; position: relative; left: 8px;">
										<i class="m-menu__link-icon flaticon-cancel"></i>
										</a>
										<div *ngIf="i === 0" style="width: 4%;"> </div>
										<span *ngIf="t.controls.amount.value > 0 && t.controls.price.value > 0" placement="top" container="body" tooltip="Price Per Ticket"  style="margin-top: 10px; position: relative; left: 20px;" class="m-form__help">{{ (t.controls.price.value / t.controls.amount.value) | currency }}</span>
									</div>
									<app-validation-display
										class="validation-display"
										[control]="t.controls.description"
										errorMessage="Please enter in a valid description"
										></app-validation-display>
									<app-validation-display
										[control]="t.controls.price"
										errorMessage="Please enter in a valid price greater than zero"
										></app-validation-display>
									<app-validation-display
										[control]="t.controls.amount"
										errorMessage="Please enter in a valid amount greater than zero"
										></app-validation-display>
								</div>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-lg-4 col-form-label"></label>
							<div class="col-lg-3">
								<a (click)="newPricingTier()" style="text-decoration: none;" href="#">+ New Tier</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- END TICKET TIERS -->

			<!-- RECEIPT INFO -->
			<div formGroupName="receiptInfo">
				<div class="m-portlet" style="width: 100%">
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text">
									CUSTOMER INFO & RECEIPT CUSTOMIZATION
								</h3>
							</div>
						</div>
					</div>
					<div class="m-portlet__body" >
						<div class="receipt-customization-container">
							<div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Major Header:
									</label>
									<div class="col-lg-3">
										<input
											formControlName="header1"
											type="text"
											id="header1"
											class="form-control m-input"
											/>
										<app-validation-display
											[control]="form.controls.receiptInfo.controls.header1"
											errorMessage="Please enter a valid major header"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Minor Header:
									</label>
									<div class="col-lg-3">
										<input
											formControlName="header2"
											type="text"
											id="header2"
											class="form-control m-input"
											/>
										<app-validation-display
											[control]="form.controls.receiptInfo.controls.header2"
											errorMessage="Please enter a valid minor header"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Subheader:
									</label>
									<div class="col-lg-3">
										<input
											formControlName="subheader"
											type="text"
											id="subheader"
											class="form-control m-input"
											/>
										<app-validation-display
											[control]="form.controls.receiptInfo.controls.subheader"
											errorMessage="Please enter a valid subheader"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
										Custom Description of Winner Selection time:
									</label>
									<div style="padding-top: 7px;" class="col-lg-3">
										<label class="switch">
										<input
										[ngModelOptions]="{standalone: true}"
										[(ngModel)]="showCustomizableWinnerText"
										[disabled]="viewing"
										type="checkbox"
										/>
										<span class="slider round"></span>
										</label>
										<i *ngIf=" eventId > 0"  class="tooltip-icon danger-icon flaticon-exclamation-2" style="top: 0;" tooltip="Can't edit this field after the event has been scheduled"></i>
									</div>
								</div>
								<div [hidden]="!showCustomizableWinnerText">
									<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
											Describe when winner will be selected:
										</label>
										<div class="col-lg-3">
											<input
											[formControl]="formControls('customWinnerSelectTime')"
											type="text"
											class="form-control m-input"
											/>
										</div>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Rules Text:
									</label>
									<div class="col-lg-3">
										<textarea
											formControlName="rulesText"
											id="subheader"
											rows="10" cols="50"
											class="form-control m-input">
								</textarea>
										<app-validation-display
											[control]="form.controls.receiptInfo.controls.rulesText"
											errorMessage="Please enter valid rules"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Bottom Header:
									</label>
									<div class="col-lg-3">
										<input
											formControlName="footerHeader"
											type="text"
											id="footerHeader"
											class="form-control m-input"
											/>
										<app-validation-display
											[control]="form.controls.receiptInfo.controls.footerHeader"
											errorMessage="Please enter a valid bottom header"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Bottom Text:
									</label>
									<div class="col-lg-3">
										<textarea
											formControlName="footerText"
											id="footerText"
											rows="10" cols="50"
											class="form-control m-input">
								</textarea>
										<app-validation-display
											[control]="form.controls.receiptInfo.controls.footerText"
											errorMessage="Please enter valid bottom text"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
										Optional Receipt Information:
									</label>

								</div>
								<div formArrayName="lineItems" *ngFor="let item of formControls('receiptInfo').controls.lineItems.controls; let i = index;">
									<div class="form-group m-form__group row" [formGroupName]="i">
										<label for="i" class="col-lg-4 col-form-label">{{item.value.name | titlecase}}:</label>
										<div class="col-lg-3">
											<label class="switch">
												<input formControlName="enabled" type="checkbox" name="i" style="padding-top: 7px;">
												<span class="slider round"></span>
											</label>
										</div>
									</div>
								</div>

							</div>
							<div style="text-align: center;">
								<div class="receipt-container" >
									<span class="receipt-header">{{formControls('receiptInfo').controls.header1.value}}</span>
									<span class="receipt-header">{{formControls('receiptInfo').controls.header2.value}}</span>
									<span class="receipt-subheader">{{formControls('receiptInfo').controls.subheader.value}}</span>
									<span class="receipt-subheader">{{vendorName}}</span>
									<span class="receipt-linebreak">__________________</span>
									<div class="receipt-lineitem">
										<span>DATE:</span> <span>08/17/21</span>
									</div>
									<div class="receipt-lineitem">
										<span>TIME:</span> <span>6:41 PM</span>
									</div>

										<div *ngIf="formControls('receiptInfo').controls.lineItems.controls[2].enabled.value" class="receipt-lineitem">
											<span>FIRST:</span> <span>JOHN</span>
										</div>
										<div *ngIf="formControls('receiptInfo').controls.lineItems.controls[3].enabled.value" class="receipt-lineitem">
											<span>LAST:</span> <span>DOE</span>
										</div>
										<div *ngIf="formControls('receiptInfo').controls.lineItems.controls[4].enabled.value" class="receipt-lineitem">
											<span>DOB:</span> <span>11/24/1991</span>
										</div>
										<div *ngIf="formControls('receiptInfo').controls.lineItems.controls[5].enabled.value" class="receipt-lineitem">
											<span>EMAIL:</span> <span>john.doe@gmail.com</span>
										</div>

									<span class="receipt-linebreak"></span>
									<div class="receipt-lineitem">
										<span>QUANTITY:</span> <span>5</span>
									</div>
									<div class="receipt-lineitem">
										<span>TOTAL:</span> <span>$20.21</span>
									</div>
									<span class="receipt-linebreak">__________________</span>
									<span class="receipt-ticketheader">TICKET NUMBERS</span>
									<div>
										<span *ngFor="let t of firstFiveTickets" style="font-size: .6rem;">{{t}} </span>
									</div>
									<span class="receipt-linebreak">__________________</span>
									<img class="receipt-qr" src="../../../assets/site/media/img/misc/qr.png">
									<span class="receipt-linebreak">__________________</span>
									<span class="receipt-text">{{ determineWinnerSelectionText(showCustomizableWinnerText) }}</span>
									<span class="receipt-linebreak">__________________</span>
									<span class="receipt-textheader">RULES</span>
									<span class="receipt-text">{{formControls('receiptInfo').controls.rulesText.value}}</span>
									<span style="display: flex; justify-content: center; padding-bottom: 15px;"></span>
									<span class="receipt-textheader">{{formControls('receiptInfo').controls.footerHeader.value}}</span>
									<span class="receipt-text">{{formControls('receiptInfo').controls.footerText.value}}</span>
								</div>
								<span class="m-form__help" style="color: lightgray;">Actual results may differ</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- END RECEIPT INFO -->

		</form>
		<!-- END FORM -->

		<div class="form-group m-form__group row">
			<div class="col-lg-12">
				<button *ngIf="!viewing || cloning" [debounceClick]  [disabled]="loading" type="submit" (click)="save()" class="btn btn-primary">
				{{ eventId ? "Update" : "Create" }}
				</button>
				<button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
				{{ viewing && !cloning ? 'Go Back' : 'Cancel'}}
				</button>
				<div *ngIf="hasValidationErrors">
					<span style="color:red">Please complete the required fields</span>
				</div>
			</div>
		</div>

	</div>
</div>
